import { NavItem } from '@config/nav'
import {
    EuiHeaderLink,
    EuiHeaderLinks,
    EuiIcon,
    EuiPopover,
    EuiSideNav,
    EuiSideNavItemType,
    EuiText,
} from '@elastic/eui'
import { buildHref, isNavActive } from '@utils/nav'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const HeaderTabletNav = ({ items }: { items: NavItem[] }) => {
    const { t } = useTranslation(['navigation'])
    const [isRestPopoverOpen, setIsRestPopoverOpen] = useState(false)
    const allwaysShownItems = items.filter((item) => item.showAlways)
    const restItems: EuiSideNavItemType<any>[] = items
        .filter((item) => !item.showAlways)
        .map((item) => ({
            id: item.id,
            name: t(item.name),
            href: buildHref(item.href),
            isSelected: isNavActive(item),
            icon: item.icon ? <EuiIcon type={item.icon} /> : undefined,
            items: item.items?.map((sub) => ({
                id: sub.id,
                name: t(sub.name),
                isSelected: isNavActive(sub),
                href: buildHref(sub.href),
            })),
        }))

    return (
        <EuiHeaderLinks gutterSize="m">
            {allwaysShownItems.map((item) => (
                <EuiHeaderLink
                    key={item.id}
                    size="m"
                    iconType={item.icon}
                    isActive={isNavActive(item)}
                >
                    <EuiText size="s">{t(item.name)}</EuiText>
                </EuiHeaderLink>
            ))}
            {restItems.length > 0 && (
                <EuiPopover
                    button={
                        <EuiHeaderLink
                            size="m"
                            onClick={() =>
                                setIsRestPopoverOpen((prev) => !prev)
                            }
                        >
                            <EuiIcon type="grabOmnidirectional" color="white" />
                        </EuiHeaderLink>
                    }
                    closePopover={() => setIsRestPopoverOpen(false)}
                    isOpen={isRestPopoverOpen}
                >
                    <EuiSideNav items={restItems} />
                </EuiPopover>
            )}
        </EuiHeaderLinks>
    )
}

export default HeaderTabletNav
